import { Button, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';

interface NoSearchResultsProps {
	searchType: string;
	query?: string;
	setQuery?: (query: string) => void;
}
export const NoSearchResults = ({ searchType, query, setQuery }: NoSearchResultsProps) => {
	return (
		<Stack align="center" justify="center" mt="xl" px="sm">
			<ThemeIcon size={60} radius={60} color="" variant="light">
				<IconSearch size={32} />
			</ThemeIcon>
			<Text fw="bold">No results found</Text>
			<Text style={{ textAlign: 'center' }}>There are no {searchType} matching "{query}".</Text>
			<Button variant="light" radius="md" onClick={() => setQuery && setQuery("")}>See all {searchType}</Button>
		</Stack>
	);
};
